module.exports = __webpack_public_path__ + "static/ps-b2577efc33909526c0951bd18c0f1077.svg";